module.exports = __webpack_public_path__ + "media/theme/top_accordion_PC_1_open-e38be734.png";